import React from 'react';
import { useForm, FormProvider, useFormContext, useFieldArray, useWatch, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// we only need this helper to achieve full test coverage, however it's impossible to type
// due to react-hook-form but mentioned below, and it's actually not exposed to consumers, the
// submitFn which users are expected to provide is well typed, thus type safety is assured
export const getHandleSubmit = (cb) => (e) => {
    e.stopPropagation();
    cb(e);
};
function Form(props) {
    const methods = useForm({
        resolver: yupResolver(props.validationSchema),
        defaultValues: props.defaultValues,
        mode: props.validationMode || 'onChange',
        shouldFocusError: props.shouldFocusError === undefined ? true : props.shouldFocusError
    });
    // we plan to always specify the type so `InferType<T>`
    const values = methods.watch();
    // @ts-ignore
    const handleSubmit = getHandleSubmit(methods.handleSubmit(props.submitFn, props.onInvalid));
    return (React.createElement(FormProvider, { ...methods },
        React.createElement("form", { onSubmit: handleSubmit }, 'children' in props ? props.children : props.render(values, methods.formState))));
}
export default Form;
export { useFormContext, useFieldArray, useWatch, Controller };
//# sourceMappingURL=index.js.map